export default "__VITE_ASSET__BkPDmFsn__"